import React, { useState } from 'react';
import { Tooltip } from 'reactstrap';
import OutlineInfo from 'react-md-icon/dist/OutlineInfo';
import onClickOutside from 'react-onclickoutside';
import PropTypes from 'prop-types';

import './FieldBuilder.scss';

const FieldTooltip = ({ tooltipContent }) => {
  const [tooltipIsOpen, setTooltipIsOpen] = useState(false);
  const toggleTooltip = () => {
    setTooltipIsOpen(!tooltipIsOpen);
  };
  FieldTooltip.handleClickOutside = () => {
    setTooltipIsOpen(false);
  };
  return (
    <div id="for-da-tooltip" className="pl-1 field-tooltip-btn">
      <OutlineInfo
        tabIndex="0"
        viewBox="0 0 24 25"
        style={{ fontSize: '1.5rem' }}
        onClick={(e) => {
              e.preventDefault();
              toggleTooltip();
            }}
        onKeyDown={(e) => {
              // 32 = spacebar, 13 = enter
              if (e.keyCode === 32 || e.keyCode === 13) {
                e.preventDefault();
                toggleTooltip();
              }
            }}
      />
      <Tooltip
        placement="bottom"
        isOpen={tooltipIsOpen}
        target="for-da-tooltip"
        container="#asure-react-app"
        className="tooltip-wrapper"
        innerClassName="bg-white text-muted px-3 py-2"
      >
        {tooltipContent}
      </Tooltip>
    </div>
  );
};

const clickOutsideConfig = {
  handleClickOutside: () => FieldTooltip.handleClickOutside,
};

FieldTooltip.defaultProps = {
  tooltipContent: '',
};

FieldTooltip.propTypes = {
  tooltipContent: PropTypes.string,
};
export default onClickOutside(FieldTooltip, clickOutsideConfig);



// WEBPACK FOOTER //
// ./src/components/Forms/FieldBuilder/FieldTooltip.jsx